import { Modal, Input, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import CloseIcon from "@mui/icons-material/Close";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PdfModal from "../../../components/PdfModal";
import ContainerModalClient from "../../../components/ClientModalInputs";
import ContainerModalComment from "../../../components/ClientModalComment";
import FileModal from "../../../components/FileModal";
import { getCameraId } from "../../../shared/utils/utils";

/**
 * Composant pour gérer tous les modals d'une ligne de collection
 */
const CollectionRowModals = ({
  timeLine,
  openModalExport,
  setOpenModalExport,
  setLoadScreen,
  pdfFile,
  setPdfFile,
  initialPdfModalAction = "export",
  displayClient,
  setDisplayClient,
  weightRef,
  newClient,
  setNewClient,
  handleSelectionChange,
  setClientCode,
  clientId,
  setClientName,
  setClientAddress,
  clientRegisteredWeight,
  setClientRegisteredWeight,
  wasteCategoryName,
  setWasteCategoryName,
  wasteCategory,
  saveWeight,
  totalWeight,
  superContainers,
  loading,
  tags,
  setTags,
  displayStatus,
  setDisplayStatus,
  displayTags,
  setDisplayTags,
  wasteName,
  displayComment,
  setDisplayComment,
  comments,
  comment,
  setComment,
  reviewComments,
  setReviewComments,
  imageData,
  openFileModal,
  setOpenFileModal,
  outputClient,
  setOutputClient,
  files,
  setFiles,
  clientName,
  clientCode,
  clientAddress,
  checkStatus,
  openModalToCharacterization,
  setOpenModalToCharacterization,
  handleSubmitSendToReview,
  reportingOptions,
  setReportingOptions,
  exportFiles,
  setExportFiles,
  generatePdf,
  onRequestPdfImageSelection,
  t,
}) => {
  return (
    <>
      {openModalExport && (
        <PdfModal
          data={timeLine}
          setOpenModalExport={setOpenModalExport}
          openModalExport={openModalExport}
          setLoadScreen={setLoadScreen}
          setPdfFile={setPdfFile}
          pdfFile={pdfFile}
          characterization={false}
          initialAction={initialPdfModalAction}
        />
      )}

      <ContainerModalClient
        data={timeLine}
        displayClient={displayClient}
        setDisplayClient={setDisplayClient}
        weightRef={weightRef}
        newClient={newClient}
        setNewClient={setNewClient}
        handleSelectionChange={handleSelectionChange}
        clientCode={clientCode}
        setClientCode={setClientCode}
        clientId={clientId}
        setClientName={setClientName}
        setClientAddress={setClientAddress}
        weight={clientRegisteredWeight}
        setWeight={setClientRegisteredWeight}
        wasteCategoryName={wasteCategoryName}
        setWasteCategoryName={setWasteCategoryName}
        wasteCategory={wasteCategory}
        saveWeight={saveWeight}
        totalWeight={totalWeight}
        superContainer={superContainers}
        isCharacterization={false}
        refreshAction={null}
        loading={loading}
        tags={tags}
        setTags={setTags}
        displayStatus={displayStatus}
        setDisplayStatus={setDisplayStatus}
        displayTags={displayTags}
        setDisplayTags={setDisplayTags}
        wasteName={wasteName}
      />

      <ContainerModalComment
        data={timeLine}
        displayComment={displayComment}
        setDisplayComment={setDisplayComment}
        superContainer={false}
        saveWeight={saveWeight}
        comments={comments}
        comment={comment}
        setComment={setComment}
        reviewComments={reviewComments}
        setReviewComments={setReviewComments}
        time={timeLine._time}
        loading={loading}
        setLoading={() => {}}
      />

      {imageData?.image_url && (
        <FileModal
          data={timeLine}
          openFileModal={openFileModal}
          setOpenFileModal={setOpenFileModal}
          outputClient={outputClient}
          setOutputClient={setOutputClient}
          files={files}
          setFiles={setFiles}
          superContainers={superContainers}
          clientName={clientName}
          clientCode={clientCode}
          clientAddress={clientAddress}
          tags={tags}
          clientRegisteredWeight={clientRegisteredWeight}
          comments={comments}
          wasteCategoryName={wasteCategoryName}
          checkStatus={checkStatus}
          cameraId={getCameraId(imageData.image_url)}
          clientId={clientId}
        />
      )}

      <Modal
        isOpen={openModalToCharacterization}
        toggle={() => {
          setOpenModalToCharacterization(!openModalToCharacterization);
        }}
        className="w-2/6"
      >
        <section className="flex justify-between py-2 px-2 border-b-1">
          <h5 className="text-blue">{t("To characterize")}</h5>
          <FontAwesomeIcon
            icon="times"
            className="close-modal"
            onClick={() => {
              setOpenModalToCharacterization(!openModalToCharacterization);
            }}
          />
        </section>
        <section className="bg-white rounded-md p-3 w-auto">
          {t("toCharacterizationMessage")}
        </section>
        <div className="w-full flex flex-end gap-2 pr-3 py-2 border-t-1">
          <button
            type="button"
            className="p-2 mr-2 border border-gray-300 bg-neutral-100 rounded-lg hover:bg-neutral-300"
            onClick={() => {
              setOpenModalToCharacterization(!openModalToCharacterization);
            }}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="p-2 w-28 text-md font-medium text-white rounded-lg bg-[#00A7A6]"
            onClick={async () => {
              await handleSubmitSendToReview();
              setOpenModalToCharacterization(!openModalToCharacterization);
            }}
          >
            {t("Validate")}
          </button>
        </div>
      </Modal>

      <Modal className="w-1/3" isOpen={reportingOptions}>
        <ModalHeader>
          <span className="text-base text-blue">{t("Compliance report")}</span>
          <CloseIcon
            style={{
              color: "var(--gray)",
              cursor: "pointer",
            }}
            onClick={() => {
              setReportingOptions(false);
            }}
          />
        </ModalHeader>
        <ModalBody className="flex flex-col gap-2">
          <span>{t("Export options")}</span>
          {files.length > 0
            ? files.map((file) => {
                const isSelected = exportFiles.includes(file);
                return (
                  <article
                    key={file}
                    className="w-full flex flex-row items-center"
                  >
                    <Input
                      className="information-data-check mt-auto"
                      type="checkbox"
                      checked={isSelected}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setExportFiles([...exportFiles, file]);
                        } else {
                          setExportFiles(exportFiles.filter((f) => f !== file));
                        }
                      }}
                      name={`import-${file}`}
                    />
                    <span>{t("Add file")}</span>
                    <span className="ml-1 text-blue">{file.split("/")[4]}</span>
                  </article>
                );
              })
            : ""}
        </ModalBody>
        <ModalFooter className="flex justify-center w-full p-2">
          <button
            type="button"
            className="p-2 text-md font-medium text-white rounded-lg"
            style={{ backgroundColor: "#00A7A6" }}
            onClick={() => {
              onRequestPdfImageSelection();
            }}
          >
            {t("generateReport")}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CollectionRowModals;
